export enum GroupRoleTypeEnum {
    Owner = 'owner',
    Member = 'member',
    Admin = 'admin',
    Moderator = 'moderator',
}

export const GROUP_ROLE_TYPE_LABEL: Record<GroupRoleTypeEnum, string> = {
    [GroupRoleTypeEnum.Owner]: 'Owner',
    [GroupRoleTypeEnum.Member]: 'Member',
    [GroupRoleTypeEnum.Admin]: 'Admin',
    [GroupRoleTypeEnum.Moderator]: 'Moderator',
};

export function getGroupRoleTypeLabel(type: GroupRoleTypeEnum): string {
    return GROUP_ROLE_TYPE_LABEL[type] || type;
}
